import React from 'react';

import './footer.scss';

import { Link } from 'react-router-dom';

import bg from '../../assets/footer-bg.jpg';
import logo from '../../assets/tmovie.png';

const Footer = () => {
    return (
        <div className="footer" style={{backgroundImage: `url(${bg})`}}>
            <div className="footer__content container">
                <div className="footer__content__logo">
                    <div className="logo">
                        <img src={logo} alt="" />
                        <Link to="/">tMovies</Link>
                    </div>
                </div>
                <div className="footer__content__menus">
                    <div className="footer__content__menu">
                        <Link to="/">Home</Link>
                        <Link to="/">Contact us</Link>
                        <Link to="/">Term of services</Link>
                        <a href="https://sonics.vercel.app/" target="_blank" rel="noopener noreferrer">About us</a>
                    </div>

                    <div className="footer__content__menu">
                        <p>Created By<a href="https://sonics.vercel.app/" target="_blank" rel="noreferrer"> Sonics</a></p>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Footer;
